import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import moment from "moment"
import { map, truncate } from "lodash"
import { Button, Table, Tooltip, Menu, Dropdown, Row } from "antd"
import Loader from "components/Loader"
import reducer from "./reducer"
import saga from "./saga"

import imageEmpty from "../../../images/emptySegment.svg"
import plusIcon from "../../../images/plus.svg"

import { PAGINATION_DEFAULT } from "../../../utils/constants"

import "./index.less"
import DrawerSegment from "./DrawerSegment"
import {
  makeSelectGroups,
  makeSelectIsErrorCreateSegment,
  makeSelectIsLoadingCreateSegment,
  makeSelectIsLoadingGroups,
  makeSelectIsLoadingSegments,
  makeSelectIsLoadingVariables,
  makeSelectVariables,
  makeSelectListSegments,
  makeSelectIsLoadingDeleteSegment,
  makeSelectIsErrorDeleteSegment,
  makeSelectIsLoadingUpdateSegment,
  makeSelectIsErrorUpdateSegment,
  makeSelectImportUpload,
  makeSelectIsDownloading,
} from "./selectors"
import {
  getTemplateSegmentCollaboratorsWatcher,
  uploadTemplateSegmentCollaboratorsWatcher,
  clearImportUpload,
  createSegmentWatcher,
  deleteSegmentWatcher,
  getGroupsWatcher,
  getSegmentsWatcher,
  getVariablesWatcher,
  updateSegmentWatcher,
} from "./actions"
import GroupsModal from "./GroupsModal"
import { ThreePointsIcon } from "../../../icons/svg/iconThreePoints"
import ModalDeleteSimple from "../../../components/ModalDeleteSimple"
import { buttonAction_btns } from "../../../components/Snowplow/config2"

/* eslint-disable react/prefer-stateless-function */
export class Segments extends React.Component {
  state = {
    showDrawer: false,
    drawerMode: "create",
    showGroupsModal: false,
    selectedVariableSegment: {},
    showConfirmDeleteModal: false,
    selectedSegmentToEdit: {},
    selectedSegmentToDelete: {},
  }

  componentDidMount = () => {
    this.props.getVariablesWatcher()
    this.props.getSegmentsWatcher()
    this.props.clearImportUpload()
    this.setState({ showDrawer: false, showConfirmDeleteModal: false })
  }

  onCreateSegmentClick = () => {
    buttonAction_btns("Crear segmento")
    this.setState({
      showDrawer: true,
      drawerMode: "create",
    })
    window.Intercom('update', { hide_default_launcher: true});
    Intercom("close")
    

  }

  onEditSegmentClick = (segment) => {
    this.setState({
      showDrawer: true,
      drawerMode: "edit",
      selectedSegmentToEdit: segment,
    })
    window.Intercom('update', { hide_default_launcher: true});
    Intercom("close")
  }

  onCloseDrawer = () => {
    this.setState({ showDrawer: false, selectedSegmentToEdit: {} })
    Intercom('update', { hide_default_launcher: false });;
  }

  onCancelDelete = () => {
    this.setState({
      selectedSegmentToDelete: {},
      showConfirmDeleteModal: false,
    })
  }

  onCreateSaveClick = (obj) => {
    if (obj.id_segment) {
      this.props.updateSegmentWatcher(obj)
    } else {
      this.props.createSegmentWatcher(obj)
    }
        Intercom('update', { hide_default_launcher: false });
      
  }

  onDeleteClick = () => {
    this.props.deleteSegmentWatcher(
      this.state.selectedSegmentToDelete.id_segment
    )
  }

  onVariableClick = (selectedSegment) => {
    this.setState({
      selectedVariableSegment: selectedSegment,
      showGroupsModal: true,
    })
  }

  onCloseGroupsModal = () => {
    this.setState({ selectedVariableSegment: {}, showGroupsModal: false })
  }

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.isErrorCreateSegment !== this.props.isErrorCreateSegment &&
      this.props.isErrorCreateSegment
    ) {
      this.setState({ showDrawer: true })
    }
    if (
      prevProps.isLoadingCreateSegment &&
      !this.props.isLoadingCreateSegment &&
      !this.props.isErrorCreateSegment
    ) {
      this.props.getSegmentsWatcher()
      this.setState({ showDrawer: false })
    }

    if (
      prevProps.isErrorUpdateSegment !== this.props.isErrorUpdateSegment &&
      this.props.isErrorUpdateSegment
    ) {
      this.setState({ showDrawer: true })
    }
    if (
      prevProps.isLoadingUpdateSegment &&
      !this.props.isLoadingUpdateSegment &&
      !this.props.isErrorUpdateSegment
    ) {
      this.props.getSegmentsWatcher()
      this.setState({ showDrawer: false })
    }

    if (
      prevProps.isErrorDeleteSegment !== this.props.isErrorDeleteSegment &&
      this.props.isErrorDeleteSegment
    ) {
      this.setState({ showConfirmDeleteModal: true })
    }
    if (
      prevProps.isLoadingDeleteSegment &&
      !this.props.isLoadingDeleteSegment &&
      this.props.isLoadingDeleteSegment !== undefined
    ) {
      this.props.getSegmentsWatcher()
      this.setState({ showConfirmDeleteModal: false })
    }
  }

  renderEmpty = () => {
    return (
      <div className="container-segments-controlpanel__empty">
        <img src={imageEmpty} />
        <p className="container-segments-controlpanel__empty__title">
          Crea segmentos
        </p>
        <p className="container-segments-controlpanel__empty__detail">
          Empieza a crear los posibles <strong>segmentos</strong> de
          colaboradores en tu organización.
        </p>
        <button
          className="container-segments-controlpanel__empty__button"
          onClick={this.onCreateSegmentClick}>
          + Crear segmento
        </button>
      </div>
    )
  }

  renderPlusButton = () => {
    return (
      <div className="container-segments-controlpanel__actions">
        <Tooltip title="Crear segmento" placement="left">
          <Button type="primary" onClick={this.onCreateSegmentClick}>
            <img src={plusIcon} />
          </Button>
        </Tooltip>
      </div>
    )
  }

  onMenuDeleteClick = (row) => {
    this.setState({
      selectedSegmentToDelete: row,
      showConfirmDeleteModal: true,
    })
  }

  renderMenu = (row) => {
    return (
      <Menu style={{ width: "120px" }}>
        <Menu.Item key="0" onClick={() => this.onEditSegmentClick(row)}>
          <span>Editar</span>
        </Menu.Item>
        <Menu.Item key="1" onClick={() => this.onMenuDeleteClick(row)}>
          <span style={{ color: "#E37879" }}>Eliminar</span>
        </Menu.Item>
      </Menu>
    )
  }

  render = () => {
    const SEGMENTS_TABLE_COLUMNS = [
      {
        title: "Segmento",
        dataIndex: "name_segment",
        sorter: (a, b) => a.name_segment.localeCompare(b.name_segment),
      },
      {
        title: "Variable",
        dataIndex: "name_segment_variable",
        sorter: (a, b) =>
          a.name_segment_variable.localeCompare(b.name_segment_variable),
        render: (text, row) => (
          <Tooltip
            title={() => {
              let groupsName = []
              for (let i = 0; i < row.groups.length; i++) {
                if (i === 10) {
                  groupsName.push(
                    <p className="container-segments-controlpanel__table__group-label">
                      Ver más
                    </p>
                  )
                  break
                }
                groupsName.push(
                  <p className="container-segments-controlpanel__table__group-label">
                    {i + 1}. {row.groups[i].name_group}
                  </p>
                )
              }
              return <>{groupsName}</>
            }}
            placement="bottom">
            <span
              className="container-segments-controlpanel__table__division-label"
              onClick={() => {
                this.onVariableClick(row)
              }}>
              {text} ({row.groups.length})
            </span>
          </Tooltip>
        ),
      },
      {
        title: "Colaboradores",
        sorter: (a, b) => a.count_collaborator - b.count_collaborator,
        render: (text, row) => (
          <div className="container-segments-controlpanel__table__group-collab">
            <span>{row.count_collaborator}</span>
            <Dropdown overlay={this.renderMenu(row)} trigger={["click"]}>
              <ThreePointsIcon style={{ color: "#2694FC" }} />
            </Dropdown>
          </div>
        ),
      },
    ]

    const { variables, groups } = this.props

    let showDrawerValid = this.state.showDrawer
    let showConfirmDeleteModalValid = this.state.showConfirmDeleteModal

    if (!showDrawerValid && this.props.isLoadingCreateSegment) {
      showDrawerValid = true
    }

    if (!showConfirmDeleteModalValid && this.props.isLoadingDeleteSegment) {
      showConfirmDeleteModalValid = true
    }

    return (
      <div className="container-segments-controlpanel" >
        <p className="container-segments-controlpanel__description">
          Los <strong>segmentos</strong> permitirán agrupar colaboradores en
          base a una variable determinada. Luego, podrán utilizarse en distintas
          secciones de la plataforma.
        </p>
        {this.props.segments.length > 0 &&
          !this.props.isLoadingSegments &&
          this.renderPlusButton()}
        {this.props.isLoadingSegments && <Loader />}
        {this.props.segments.length === 0 &&
          !this.props.isLoadingSegments &&
          this.renderEmpty()}
        {this.props.segments.length > 0 && !this.props.isLoadingSegments && (
          <Table
            className="container-segments-controlpanel__table"
            columns={SEGMENTS_TABLE_COLUMNS}
            dataSource={this.props.segments}
            pagination={PAGINATION_DEFAULT}
          />
        )}
        <DrawerSegment
          {...this.props}
          onCreateSaveClick={this.onCreateSaveClick}
          showDrawerSegment={this.state.showDrawer}
          getTemplateSegmentCollaborators={
            this.props.getTemplateSegmentCollaboratorsWatcher
          }
          uploadTemplateSegmentCollaborators={
            this.props.uploadTemplateSegmentCollaboratorsWatcher
          }
          isDownloading={this.props.isDownloading}
          importUpload={this.props.importUpload}
          clearImportUpload={this.props.clearImportUpload}
          selectedSegment={this.state.selectedSegmentToEdit}
          mode={this.state.drawerMode}
          closeDrawer={this.onCloseDrawer}
          variables={variables}
          groups={groups}
        />
        <GroupsModal
          onOk={this.onCloseGroupsModal}
          show={this.state.showGroupsModal}
          segment={this.state.selectedVariableSegment}
        />
        <ModalDeleteSimple
          visible={this.state.showConfirmDeleteModal}
          onCancel={this.onCancelDelete}
          onOk={this.onDeleteClick}
          loading={this.props.isLoadingDeleteSegment}
          content={
            <>
              <p
                style={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  fontWeight: 600,
                  fontSize: 14,
                  textAlign: "center",
                }}>
                {`¿Estás seguro de que deseas eliminar el segmento ${this.state.selectedSegmentToDelete.name_segment}?`}
              </p>
              {this.state.selectedSegmentToDelete.countMeasures > 0 && (
                <p>
                  {`Este segmento está siendo utilizado en ${this.state.selectedSegmentToDelete.countSurveys} cuestionarios y ${this.state.selectedSegmentToDelete.countMeasures} mediciones. Al eliminarlo se perderá la asociación y las respuestas registradas si es que existen. La acción no será reversible.`}
                </p>
              )}
              {this.state.selectedSegmentToDelete.countMeasures === 0 && (
                <p>
                  No será posible visualizar el segmento en ninguna instancia
                  del sistema, y la acción no será reversible.
                </p>
              )}
            </>
          }
        />
      </div>
    )
  }
}

Segments.propTypes = {}

const mapStateToProps = createStructuredSelector({
  variables: makeSelectVariables(),
  isLoadingVariables: makeSelectIsLoadingVariables(),
  groups: makeSelectGroups(),
  isGroupsLoading: makeSelectIsLoadingGroups(),
  isLoadingCreateSegment: makeSelectIsLoadingCreateSegment(),
  isErrorCreateSegment: makeSelectIsErrorCreateSegment(),
  isLoadingUpdateSegment: makeSelectIsLoadingUpdateSegment(),
  isErrorUpdateSegment: makeSelectIsErrorUpdateSegment(),
  isLoadingDeleteSegment: makeSelectIsLoadingDeleteSegment(),
  isErrorDeleteSegment: makeSelectIsErrorDeleteSegment(),
  segments: makeSelectListSegments(),
  isLoadingSegments: makeSelectIsLoadingSegments(),
  importUpload: makeSelectImportUpload(),
  isDownloading: makeSelectIsDownloading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplateSegmentCollaboratorsWatcher: (params) =>
      dispatch(getTemplateSegmentCollaboratorsWatcher(params)),
    uploadTemplateSegmentCollaboratorsWatcher: (params) =>
      dispatch(uploadTemplateSegmentCollaboratorsWatcher(params)),
    getVariablesWatcher: () => dispatch(getVariablesWatcher()),
    clearImportUpload: () => dispatch(clearImportUpload()),
    getSegmentsWatcher: () => dispatch(getSegmentsWatcher()),
    getGroupsWatcher: (params) => dispatch(getGroupsWatcher(params)),
    createSegmentWatcher: (params) => dispatch(createSegmentWatcher(params)),
    updateSegmentWatcher: (params) => dispatch(updateSegmentWatcher(params)),
    deleteSegmentWatcher: (params) => dispatch(deleteSegmentWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "segments", reducer })
const withSaga = injectSaga({ key: "segments", saga })

export default compose(withReducer, withSaga, withConnect)(Segments)
